function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSunFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16 2a1 1 0 00-1 1v4h2V3a1 1 0 00-1-1zM17 29v-4h-2v4a1 1 0 102 0z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 16a7 7 0 11-14 0 7 7 0 0114 0zm-2 0a5 5 0 11-10 0 5 5 0 0110 0z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.1 7.515A1 1 0 117.515 6.1l2.828 2.828-1.414 1.414L6.1 7.515zM23.071 21.657l-1.414 1.414 2.828 2.828a1 1 0 001.415-1.414l-2.829-2.828zM3 17a1 1 0 110-2h4v2H3zM29 15h-4v2h4a1 1 0 100-2zM7.515 25.9A1 1 0 016.1 24.485l2.828-2.828 1.414 1.414L7.515 25.9zM21.657 8.929l1.414 1.414L25.9 7.515A1 1 0 0024.485 6.1l-2.828 2.828z",
    fill: props.color
  }));
}

export default SvgIconSunFilled;